var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-year-logo-wrapper" },
    [
      _vm.isNewYearPeriod
        ? _c("div", { staticClass: "logo-flip-container" }, [
            _c("div", { staticClass: "logo-flip-inner" }, [
              _c(
                "div",
                { staticClass: "logo-flip-front" },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "logo-flip-back" }, [
                _c(
                  "svg",
                  {
                    staticClass: "christmas-tree",
                    attrs: {
                      viewBox: "0 0 100 120",
                      width: "32",
                      height: "38",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "42",
                        y: "95",
                        width: "16",
                        height: "20",
                        fill: "#8B4513",
                      },
                    }),
                    _vm._v(" "),
                    _c("polygon", {
                      attrs: {
                        points:
                          "50,5 20,40 35,40 15,65 30,65 10,95 90,95 70,65 85,65 65,40 80,40",
                        fill: "#228B22",
                      },
                    }),
                    _vm._v(" "),
                    _c("polygon", {
                      attrs: {
                        points:
                          "50,0 52,8 60,8 54,13 56,21 50,16 44,21 46,13 40,8 48,8",
                        fill: "#FFD700",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "35", cy: "50", r: "4", fill: "#FF0000" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "65", cy: "55", r: "4", fill: "#FFD700" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "45", cy: "70", r: "4", fill: "#1E90FF" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "58", cy: "75", r: "4", fill: "#FF69B4" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "30", cy: "80", r: "4", fill: "#FFD700" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "70", cy: "85", r: "4", fill: "#FF0000" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "50", cy: "45", r: "3", fill: "#00CED1" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "40", cy: "88", r: "3", fill: "#9400D3" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "60", cy: "90", r: "3", fill: "#32CD32" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      staticClass: "tree-light light-1",
                      attrs: { cx: "28", cy: "60", r: "2", fill: "#FFFF00" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      staticClass: "tree-light light-2",
                      attrs: { cx: "72", cy: "65", r: "2", fill: "#FFFF00" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      staticClass: "tree-light light-3",
                      attrs: { cx: "25", cy: "85", r: "2", fill: "#FFFF00" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      staticClass: "tree-light light-4",
                      attrs: { cx: "75", cy: "80", r: "2", fill: "#FFFF00" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      staticClass: "tree-light light-5",
                      attrs: { cx: "50", cy: "60", r: "2", fill: "#FFFF00" },
                    }),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }